var _polygon, _polygon2, _path, _path2, _path3, _rect, _rect2, _polygon3, _rect3, _rect4, _polygon4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileshare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    height: "50px",
    width: "50px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#59B4D9",
    points: "47.4,17.5 43.5,13.6 41.8,12 41.6,12 13,12 13,50 49,50 49,19.4 49,19.2 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.8,
    fill: "#FFFFFF",
    points: "41,14 15,14 15,48 47,48 47,20 41,20 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#59B4D9",
    d: "M20,39.1c0-0.5,0.4-0.9,0.9-0.9h12.4c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9H20.9 C20.4,40,20,39.6,20,39.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#59B4D9",
    d: "M20,32.9c0-0.5,0.4-0.9,0.9-0.9h20.5c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9H20.9 C20.4,33.8,20,33.4,20,32.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#59B4D9",
    d: "M20,27.1c0-0.5,0.4-0.9,0.9-0.9h20.5c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9H20.9 C20.4,28,20,27.6,20,27.1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    fill: "#59B4D9",
    width: 29,
    height: 6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    fill: "#59B4D9",
    width: 6,
    height: 40
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.8,
    fill: "#FFFFFF",
    points: "5,2 3,2 3,38 7,38 7,6 30,6 30,2 "
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 6,
    fill: "#59B4D9",
    width: 29,
    height: 6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 6,
    fill: "#59B4D9",
    width: 6,
    height: 38
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.8,
    fill: "#FFFFFF",
    points: "11,8 9,8 9,42 13,42 13,12 36,12 36,8 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileshare);
export default __webpack_public_path__ + "static/media/fileshare.914639e786d420d64d67b538ddfbd734.svg";
export { ForwardRef as ReactComponent };